import React from 'react';

const SkeletonBubble = ({ align = 'left', line1Width = '90%', line2Width = '40%' }) => {
  const isRight = align === 'right';

  const AvatarPlaceholder = () => (
    <div
      style={{
        width: 30,
        height: 30,
        borderRadius: '50%',
        backgroundColor: '#dbdbdb', // Solid grey avatar
        flexShrink: 0,
        margin: isRight ? '0 0 0 12px' : '0 12px 0 0',
      }}
    />
  );

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: isRight ? 'flex-end' : 'flex-start',
        marginBottom: 20,
        padding: '0 15px',
        alignItems: 'center', // Centers avatar with bubble
      }}
    >
      {!isRight && <AvatarPlaceholder />}
      
      <div
        style={{
          width: '50%',
          minWidth: 220,
          maxWidth: 400,
          backgroundColor: '#ffffff',
          borderRadius: 8,
          padding: '12px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          boxShadow: '0 1px 1px rgba(0,0,0,0.05)',
        }}
      >
        <div
          style={{
            height: 10,
            borderRadius: 5,
            width: line1Width,
            background: 'linear-gradient(90deg, #e5e5e5 25%, #f2f2f2 50%, #e5e5e5 75%)',
            backgroundSize: '200% 100%',
            animation: 'chat-skeleton-shimmer 1.6s ease-in-out infinite',
          }}
        />
        <div
          style={{
            height: 10,
            borderRadius: 5,
            width: line2Width,
            background: 'linear-gradient(90deg, #e5e5e5 25%, #f2f2f2 50%, #e5e5e5 75%)',
            backgroundSize: '200% 100%',
            animation: 'chat-skeleton-shimmer 1.6s ease-in-out infinite',
          }}
        />
      </div>

      {isRight && <AvatarPlaceholder />}
    </div>
  );
};

const SkeletonDate = () => null; // The image doesn't show dates, so we can hide this or style it lightly

const ChatSkeleton = () => (
  <div style={{ paddingTop: 70, paddingBottom: 60 }}>
    <style>{`
      @keyframes chat-skeleton-shimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `}</style>
    <SkeletonBubble align="left" line1Width="85%" line2Width="35%" />
    <SkeletonBubble align="right" line1Width="90%" line2Width="40%" />
    <SkeletonBubble align="left" line1Width="80%" line2Width="30%" />
    <SkeletonBubble align="right" line1Width="88%" line2Width="45%" />
    <SkeletonBubble align="left" line1Width="95%" line2Width="38%" />
    <SkeletonBubble align="right" line1Width="85%" line2Width="30%" />
  </div>
);

export const LoadMoreSkeleton = () => (
  <div style={{ padding: '8px 15px' }}>
    <style>{`
      @keyframes chat-skeleton-shimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `}</style>
    <SkeletonBubble align="left" line1Width="80%" line2Width="30%" />
    <SkeletonBubble align="right" line1Width="85%" line2Width="40%" />
  </div>
);

export default ChatSkeleton;
